// Features: the parser knows all 21, always. Hiding only affects the Export picker.
export const ALL_FEATURES = [
  'ANIM', 'BIS', 'IMGT-MODEL', 'MIX', 'IMGT-FLATLAY', 'IMGT-CHANGE', 'IMGT-STAGE', 'IMGT-GHOST', 'IMGT-BEAUTIFY', 'BATCH',
  'AIBG', 'IGSTORY', 'IGPOST', 'LIPOST', 'LOGO', 'AIFILL', 'RETOUCH', 'CATALOG', 'RnD', 'ANIM-REELS', 'BUNDLE',
];
export const DEFAULT_ACTIVE = ALL_FEATURES.slice(0, 10);
export const SHORTCUT_COUNT = 7; // first seven active features carry the keys 1–7

const LS = 'timbo_export_features_v1';
// Stored config: ordered list of ACTIVE features. Unknown names are dropped, so a stale value cannot invent a feature.
export function getActiveFeatures() {
  try {
    const saved = JSON.parse(localStorage.getItem(LS));
    if (Array.isArray(saved)) { const ok = saved.filter(f => ALL_FEATURES.includes(f)); if (ok.length) return ok; }
  } catch {}
  return [...DEFAULT_ACTIVE];
}
export function saveActiveFeatures(list) { try { localStorage.setItem(LS, JSON.stringify(list)); } catch {} }

// Default feature for a new form: the Studio's feature if it is active, otherwise the first active one.
export function defaultFeature(active, studioTag) { return active.includes(studioTag) ? studioTag : active[0]; }
